import { render } from "./DetailForm.vue?vue&type=template&id=a5f93fb0&scoped=true"
import script from "./DetailForm.vue?vue&type=script&lang=js"
export * from "./DetailForm.vue?vue&type=script&lang=js"

import "./DetailForm.vue?vue&type=style&index=0&id=a5f93fb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f93fb0"],['__file',"src/components/h5/layout/DetailForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5f93fb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5f93fb0', __exports__)) {
    api.reload('a5f93fb0', __exports__)
  }
  
  module.hot.accept("./DetailForm.vue?vue&type=template&id=a5f93fb0&scoped=true", () => {
    api.rerender('a5f93fb0', render)
  })

}


export default __exports__